import { render } from "./AgencyCentre.vue?vue&type=template&id=48030144"
import script from "./AgencyCentre.vue?vue&type=script&lang=js"
export * from "./AgencyCentre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__